var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18034_4857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09464 14.3903C4.97761 14.0577 3.98331 13.4403 3.196 12.6222C3.48971 12.2741 3.66671 11.8243 3.66671 11.3332C3.66671 10.2286 2.77128 9.3332 1.66671 9.3332C1.59989 9.3332 1.53384 9.33651 1.4687 9.34291C1.37997 8.90907 1.33337 8.45994 1.33337 7.99987C1.33337 7.303 1.4403 6.63111 1.63864 5.99967C1.64798 5.99981 1.65733 5.99987 1.66671 5.99987C2.77128 5.99987 3.66671 5.10444 3.66671 3.99987C3.66671 3.68277 3.59291 3.38294 3.46157 3.11654C4.23254 2.39967 5.17354 1.86318 6.21741 1.57422C6.54817 2.22257 7.22227 2.66655 8.00004 2.66655C8.77781 2.66655 9.45191 2.22257 9.78267 1.57422C10.8265 1.86318 11.7675 2.39967 12.5385 3.11654C12.4072 3.38294 12.3334 3.68277 12.3334 3.99987C12.3334 5.10444 13.2288 5.99987 14.3334 5.99987C14.3427 5.99987 14.3521 5.99981 14.3614 5.99967C14.5598 6.63111 14.6667 7.303 14.6667 7.99987C14.6667 8.45994 14.6201 8.90907 14.5314 9.34291C14.4662 9.33651 14.4002 9.3332 14.3334 9.3332C13.2288 9.3332 12.3334 10.2286 12.3334 11.3332C12.3334 11.8243 12.5104 12.2741 12.8041 12.6222C12.0168 13.4403 11.0225 14.0577 9.90544 14.3903C9.64764 13.5838 8.89204 12.9999 8.00004 12.9999C7.10804 12.9999 6.35244 13.5838 6.09464 14.3903Z",
    stroke: "#353945",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 10.3337C9.28863 10.3337 10.3333 9.28899 10.3333 8.00033C10.3333 6.71166 9.28863 5.66699 7.99996 5.66699C6.71129 5.66699 5.66663 6.71166 5.66663 8.00033C5.66663 9.28899 6.71129 10.3337 7.99996 10.3337Z",
    stroke: "#353945",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18034_4857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon8);
export default __webpack_public_path__ + "static/media/navicon8.0492018046a6aff6b3f4ef7869424a0b.svg";
export { ForwardRef as ReactComponent };